export const GADatalayerEcardCheckoutSteps = [
    {
        stepNumber: 0,
        stepName: "Personalise",     
        displayStepNumber: 1
    },
    {
        stepNumber: 4,
        stepName: "Schedule",    
        displayStepNumber: 2
    },
    {
        stepNumber: 5,
        stepName: "Add donation",      
        displayStepNumber: 3
    }
];